module.exports = __webpack_public_path__ + "static/media/ico-case-full.b610876d.svg";